import React from 'react'
import { __DEV__ } from '../constants'
import { isInExtension } from '../extension'

const STORAGE_KEY = 'test'
const CACHE = { web: {}, extension: {} }

const LocalStoragePermissionContext = React.createContext(false)

/* istanbul ignore next */
function log(...args) {
  if (__DEV__) {
    console.log(...args)
  }
}

/* istanbul ignore next */
function addToExtensionStorage(data) {
  return new Promise(resolve => {
    return window.chrome?.storage?.local?.set(data, () => resolve(true))
  })
}

/* istanbul ignore next */
function removeFromExtensionStorage(...keys) {
  return new Promise(resolve => {
    return window.chrome?.storage?.local?.remove(keys, () => resolve(true))
  })
}

export const canAccessWebLocalStorage = () => {
  if (CACHE.web.gotStatus) return CACHE.web.status

  let canAccess = false

  try {
    window.localStorage.setItem(STORAGE_KEY, STORAGE_KEY)
    window.localStorage.removeItem(STORAGE_KEY)
    canAccess = true
  } catch (e) {}

  log('canAccessWebLocalStorage:', canAccess)
  CACHE.web = { gotStatus: true, status: canAccess }
  return canAccess
}

/* istanbul ignore next */
export const canAccessExtensionLocalStorage = async () => {
  if (CACHE.extension.gotStatus) return CACHE.extension.status

  let canAccess = false
  try {
    await addToExtensionStorage({ [STORAGE_KEY]: STORAGE_KEY })
    await removeFromExtensionStorage(STORAGE_KEY)
    canAccess = true
  } catch (err) {}

  log('canAccessExtensionLocalStorage:', canAccess)
  CACHE.extension = { gotStatus: true, status: canAccess }
  return canAccess
}

/* istanbul ignore next */
export const canAccessLocalStorage = isInExtension()
  ? canAccessExtensionLocalStorage
  : canAccessWebLocalStorage

export const useCanAccessLocalStorage = () => {
  const [permission, setPermission] = React.useState(false)

  async function handlePermission() {
    setPermission(await canAccessLocalStorage())
  }

  React.useEffect(() => {
    handlePermission()
  }, [])

  return permission
}

/* istanbul ignore next */
export const LocalStoragePermissionProvider = ({ children }) => {
  const permission = useCanAccessLocalStorage()

  return (
    <LocalStoragePermissionContext.Provider value={permission}>
      {children}
    </LocalStoragePermissionContext.Provider>
  )
}

/* istanbul ignore next */
export const useLocalStoragePermission = () => {
  return React.useContext(LocalStoragePermissionContext)
}
